import { useQuery } from "urql"

import "@/screens/Products/graphql/companyName.query"

import {
  GetCompanyNameByIdDocument,
  type GetCompanyNameByIdQuery,
  type GetCompanyNameByIdQueryVariables,
} from "@/graphql/codegen/graphql"

interface UseGetVendorNameReturn {
  vendorName: string | undefined
  isFetching: boolean
}

export const useGetVendorName = (vendorCompanyId: string | undefined): UseGetVendorNameReturn => {
  const [{ data, fetching }] = useQuery<GetCompanyNameByIdQuery, GetCompanyNameByIdQueryVariables>({
    query: GetCompanyNameByIdDocument,
    variables: { companyId: vendorCompanyId ?? "" },
    pause: !vendorCompanyId,
  })

  const vendorName =
    data?.company.get.__typename === "CompanyGetSuccess" ? (data.company.get.company.name ?? undefined) : undefined

  return { vendorName, isFetching: fetching }
}
